import axios from 'axios'

export interface SignedMedia {
  signedUrl: string
  fileName: string
}

export interface SignedMediaResult {
  data: SignedMedia | null
  error: any
}

export type SignedMediaRequest = () => Promise<SignedMediaResult>

export const requestFreshSignedMedia = async (request: SignedMediaRequest): Promise<SignedMedia> => {
  const { data, error } = await request()

  if (error) throw error
  if (!data || !data.signedUrl) throw new Error('The media service did not return a signed URL')

  return data
}

export const downloadFreshSignedMedia = async (
  request: SignedMediaRequest,
  fetchBlob: (url: string) => Promise<{ data: any }> = (url) => axios.get(url, { responseType: 'blob' })
): Promise<{ data: any; fileName: string }> => {
  let lastError: any

  for (let attempt = 0; attempt < 2; attempt += 1) {
    const media = await requestFreshSignedMedia(request)

    try {
      const response = await fetchBlob(media.signedUrl)
      return { data: response.data, fileName: media.fileName }
    } catch (error) {
      lastError = error
    }
  }

  throw lastError
}
